export const translations = {
    'PTBR': {
        signupTitle: 'Cadastro',
        name: 'Nome',
        password: 'Senha',
        confirmPassword: 'Confirmar Senha',
        signup: 'Cadastrar',
        goBackToLogin: 'Voltar para login',
        stillDeveloping: 'Ainda em desenvolvimento',
        error: 'Houve um erro, por favor tente novamente',
        requiredFieldsMessage: 'Os seguintes campos são obrigatórios: ',
        passwordMismatch: 'As senhas não conferem.',
        accountCreated: 'Conta criada com sucesso!',
    },
    'EN': {
        signupTitle: 'Sign Up',
        name: 'Name',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        signup: 'Sign Up',
        goBackToLogin: 'Back to login',
        stillDeveloping: 'Still in development',
        error: 'There was an error, please try again',
        requiredFieldsMessage: 'The following fields are required: ',
        passwordMismatch: 'The passwords do not match.',
        accountCreated: 'Account created successfully!',
    }
}

export type LanguageKeys = keyof typeof translations;